/* global Selectize, Chart */

import $ from 'jquery';
import { queryString, redirectWithParams } from '@/js/modules/query_params';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  if ($('body').is('#financials')) {
    // scroll to financials-table if table-actions is made
    const params = queryString();
    if (Object.keys(params).length && !Object.keys(params).includes('date_filter')) {
      // parameters like q, sort, filter are provided for financials-table
      // date_filter parameter is provided for financials-chart
      const dims = document.getElementById('financials-table').getBoundingClientRect();
      window.scrollTo(window.scrollX, dims.top - 55);
    }
  }

  $(document).ready(function () {
    if (typeof Selectize !== 'undefined') {
      // Filter drop downs with a selectized field on top
      $('.financials-filter-dropdown').selectize({
        create: false,
        persist: false,
        openOnFocus: false,
        onInitialize() {
          const that = this;

          this.$control.on('click', function () {
            that.ignoreFocusOpen = true;
            setTimeout(function () {
              that.ignoreFocusOpen = false;
            }, 50);
          });
        },

        onFocus() {
          if (!this.ignoreFocusOpen) {
            this.open();
          }
        },
      });

      $('.financials-filter-dropdown--date-filter, .field--financials-date-filter').on(
        'change',
        (e) => {
          const params = queryString();
          params['date_filter'] = $(e.currentTarget).val();
          redirectWithParams(params);
        }
      );
    }
  });

  $(document).ready(function () {
    if ($('#financials-chart').length > 0) {
      const ctx = document.getElementById('financials-chart').getContext('2d');
      const chartData = $('.financials-chart').data('chart');

      const numberWithCurrency = (value) => {
        value = Number(value).toLocaleString('en');
        const currencySymbol = $('meta[name="currency-symbol"]').attr('content');
        return value < 0 ? '-' + currencySymbol + -value : currencySymbol + value;
      };

      Chart.defaults.global.defaultFontFamily = 'Source Sans Pro';
      new Chart(ctx, {
        type: 'bar',
        data: chartData,
        options: {
          maintainAspectRatio: false,
          legend: {
            display: false,
          },
          tooltips: {
            mode: 'index',
            intersect: false,
            bodySpacing: 12,
            xPadding: 12,
            yPadding: 12,
            cornerRadius: 3,
            itemSort(a, b) {
              return b.datasetIndex - a.datasetIndex;
            },
            callbacks: {
              title: () => {},
              label: (tooltipItem, data) => {
                const labelKey = data.datasets[tooltipItem.datasetIndex].label;
                const labelVal = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

                return `    ${labelKey}: ${numberWithCurrency(labelVal)}`;
              },
            },
          },
          responsive: true,
          scales: {
            xAxes: [
              {
                gridLines: {
                  display: false,
                },
                stacked: true,
              },
            ],
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  userCallback(value, index, values) {
                    return numberWithCurrency(value);
                  },
                },
              },
            ],
          },
        },
      });
    }
  });
});
